import { useEffect, useState } from "react";
import { Icon } from "./Icon";
import { bridge, hasBridge } from "@/lib/devices/bridge";

/**
 * Chop etish tugmasi.
 *
 * Faqat Electron ichida ko'rinadi: brauzerda `window.print()`
 * ham bor, lekin u printerni tanlash va holatni qaytarish
 * imkonini bermaydi — xodim chop etilgan-etilmaganini
 * bilmasdi.
 *
 * Printer tanlovi TIZIM dialogida qoladi (`silent: false`):
 * nechta nusxa va qaysi printerga ketayotgani ko'rinib turishi
 * kerak.
 */
export function PrintButton({ label = "Chop etish" }: { label?: string }) {
  const [available, setAvailable] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!hasBridge()) return;
    // Printer ro'yxati SO'RALADI: ko'prik bor-u, tizimda
    // birorta printer bo'lmasa, tugma ishlamaydigan tugma
    // bo'lib qolardi.
    void bridge()
      ?.printers()
      .then((list) => setAvailable(list.documents.length > 0))
      .catch(() => setAvailable(false));
  }, []);

  if (!available) return null;

  return (
    <>
      <button
        type="button"
        className="btn btn-tonal"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError(null);
          void bridge()
            ?.print()
            .then((result) => {
              if (!result.printed && result.reason) setError(result.reason);
            })
            .catch((cause) => setError(String(cause)))
            .finally(() => setBusy(false));
        }}
      >
        <Icon name="printer" size={16} />
        {label}
      </button>
      {error && <span className="field-hint" style={{ color: "var(--error)" }}>{error}</span>}
    </>
  );
}
